import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, PercentPipe } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxCurrencyModule, OfferDisclosuresModule } from 'common';
import { SharedModule } from '../shared/shared.module';
import { CalculatorRoutingModule } from './calculator-routing.module';
import { LocCalculatorComponent } from './loc/loc-calculator.component';
import { OfferPageStatusMessageComponent } from './offer-page-status/offer-page-status-message.component';
import { TermCalculatorComponent } from './term/term-calculator.component';
import { SummaryCalculatorComponent } from './summary/summary-calculator.component';
import { SummaryOfferWidgetComponent } from './summary/offer-widget/summary-offer-widget.component';
import { LawCalculatorComponent } from './law/law-calculator.component';
import { CalculatorDisclosuresComponent } from './disclosures/calculator-disclosures.component';
import { LinkYourBankModule } from '../shared/link-your-bank/link-your-bank.module';
import { AprCalculatorModule } from './apr/apr-calculator.module';

@NgModule({
  imports: [
    CommonModule,
    MatSliderModule,
    MatInputModule,
    MatFormFieldModule,
    NgxCurrencyModule.forRoot({
      align: "left",
      allowNegative: false,
      allowZero: true,
      decimal: ".",
      precision: 2,
      prefix: "$",
      suffix: "",
      thousands: ",",
      nullable: true
    }),
    SharedModule,
    CalculatorRoutingModule,
    LinkYourBankModule,
    AprCalculatorModule,
    OfferDisclosuresModule
  ],
  declarations: [
    LocCalculatorComponent,
    TermCalculatorComponent,
    LawCalculatorComponent,
    SummaryOfferWidgetComponent,
    SummaryCalculatorComponent,
    CalculatorDisclosuresComponent,
    OfferPageStatusMessageComponent
  ],
  providers: [
    PercentPipe,
    CurrencyPipe
  ]
})
export class CalculatorModule { }
